import { useContext } from 'react';
import { useLazyQuery } from '@apollo/client';
import { ExperienceContext } from '~/@thd-nucleus/experience-context';
import getShippingQuery from '../queries/shipping/getShippingQuery';
import { useQuery } from './useQuery';

const useShipping = ({
  itemId,
  zipCode,
  storeId,
  quantity,
  price,
  ssr = true,
  lazy = false
}) => {
  let sId = storeId;
  const ctx = useContext(ExperienceContext);
  if (!sId && ctx && ctx.store) {
    sId = ctx.store.storeId;
  }

  const Query = getShippingQuery();

  const opts = {
    ssr,
    errorPolicy: 'all',
    variables: {
      itemId,
      storeId: sId,
      zipCode,
      quantity,
      price
    }
  };

  if (lazy) {
    return useLazyQuery(Query, opts);
  }
  return useQuery(Query, opts);

};

export default useShipping;
